import { IMAGE_KEY } from '@techchange/pm-specs';
import { Plugin, PluginKey } from 'prosemirror-state';

import ImageView from '../nodeView';

export const imageViewPluginKey = new PluginKey('imageViewPlugin');

/**
 * Plugin that manages the view and state for selected images.
 *
 * @returns {Object} ProseMirror plugin object.
 */
const imageViewPlugin = () =>

	new Plugin({

		key: imageViewPluginKey,

		state: {

			init() {

				return {

					/**
					 * The selected image node.
					 */
					imageNode: null,

					/**
					 * The absolute position of the node in the document.
					 */
					imagePos: null,

				};

			},

			// Updates the plugin state given incoming editor transaction
			apply(tr, pluginState, prevState, nextState) {

				const { node, from } = nextState.selection;

				let imageNode, imagePos;

				if (node && node.type === nextState.schema.nodes[IMAGE_KEY]) {

					imageNode = node;
					imagePos = from;

				}

				const nextPluginState = {
					imageNode,
					imagePos,
				};

				return nextPluginState;

			},

		},

		props: {

			nodeViews: {

				[IMAGE_KEY]: (node, view) =>
					new ImageView(node, view),

			},

		},

	});

export default imageViewPlugin;
